const roundRate = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return 0;
  return Number(num.toFixed(2));
};

const formatRate = (value) => {
  const rounded = roundRate(value);
  if (Number.isInteger(rounded)) return String(rounded);
  return rounded.toFixed(2).replace(/\.?0+$/, "");
};

export const inferCombinedGstRate = ({
  rate = 0,
  taxable = 0,
  total = 0,
  cgst = 0,
  sgst = 0,
}) => {
  const directRate = roundRate(rate);
  if (directRate > 0) return directRate;

  const taxableAmount = Number(taxable) || 0;
  if (taxableAmount <= 0) return 0;

  const totalTax =
    Number(total) ||
    (Number(cgst) || 0) + (Number(sgst) || 0);

  if (totalTax <= 0) return 0;
  return roundRate((totalTax / taxableAmount) * 100);
};

export const getUniformSplitGstRate = (rows = []) => {
  const rates = Array.from(
    new Set(
      (Array.isArray(rows) ? rows : [])
        .map((row) =>
          inferCombinedGstRate({
            rate:
              row?.rate ??
              row?.taxRate ??
              row?.percent ??
              row?.percentage,
            taxable:
              row?.taxableamount ??
              row?.taxable ??
              row?.taxableAmount,
            total:
              row?.total ??
              row?.totalamount ??
              row?.totalGST ??
              row?.amount,
            cgst: row?.cgst ?? row?.cgstAmount ?? row?.cgstvalue,
            sgst: row?.sgst ?? row?.sgstAmount ?? row?.sgstvalue,
          })
        )
        .filter((value) => value > 0)
    )
  );

  if (!rates.length) return 0;
  if (rates.length === 1) return roundRate(rates[0] / 2);

  // Tax amounts are rounded to paise per line, so one configured GST rate can
  // be inferred as nearby values (for example 4.99%, 5% and 5.01%). Treat that
  // small spread as one rate instead of hiding the percentage from the label.
  const minRate = Math.min(...rates);
  const maxRate = Math.max(...rates);
  if (maxRate - minRate <= 0.1) {
    const averageRate =
      rates.reduce((total, value) => total + value, 0) / rates.length;
    return roundRate(averageRate / 2);
  }

  return 0;
};

export const formatSplitTaxLabel = (
  name,
  splitRate = 0,
  suffixOrOptions = "",
  maybeOptions = {}
) => {
  const safeName = String(name || "").trim() || "GST";
  const options =
    suffixOrOptions && typeof suffixOrOptions === "object"
      ? suffixOrOptions
      : maybeOptions;
  const suffix =
    typeof suffixOrOptions === "string"
      ? suffixOrOptions
      : options?.suffix || "";
  const showRate = options?.showRate ?? true;
  const extra = suffix ? ` ${suffix}` : "";
  return showRate && splitRate > 0
    ? `${safeName} (${formatRate(splitRate)}%)${extra}`
    : `${safeName}${extra}`;
};
